import {
  Component, Vue, Watch, Mixins, Ref,
} from 'vue-property-decorator';
import CryptoJS from 'crypto-js';
import firebase from '@/plugins/firebase';
// import Minio from 'minio';
import S3 from 'aws-sdk/clients/s3';

// import FileHasher from '@/plugins/fileHasher';


@Component({
  name: 'DropView',
  components: {
    // 'file-column': require('@/components/FileColumn.vue').default,
  },
})

export default class DropView extends Vue {
	from = '';

	project = '';

	message = '';

	dropping = false;

	sendingMessage = false;

	// storedDrops: string[] = [];
	// loadStoredDrops(){
	// 	for (var i = 0; i < window.localStorage.length; i++){
	// 		const id = window.localStorage.key(i)!.match(/^drop\-(.+)\-credentials$/);
	// 		if (id && id.length > 0){
	// 			if (!this.storedDrops.includes())
	// 			this.storedDrops.push(id[1]);
	// 			this.$store.dispatch('drops/subscribe', id[1]);
	// 		}
	// 	}
	// }
	// get history() {
	// 	const ids: string[] = [];
	// 	for (var i = 0; i < window.localStorage.length; i++){
	// 		const id = window.localStorage.key(i)!.match(/^drop\-(.+)\-credentials$/);
	// 		if (id && id.length > 0){
	// 			ids.push(id[1]);
	// 			this.$store.dispatch('drops/subscribe', id[1]);
	// 		}
	// 	}
	// 	return ids;
	// }
	get history(): string[] {
	  return this.$store.state.drops.recent;
	}

	get recent() {
	  return this.history
	    .filter(id => id !== this.id)
	    .map(id => this.$store.state.drops.all[id] as Drop)
	    .filter(drop => Boolean(drop))
	    .sort((a, b) => b.folder.localeCompare(a.folder));
	}

	forget(id: string) {
	  this.$store.commit('drops/forget', id);
	}

	get id() {
	  return this.$route.params.id;
	}

	mounted() {
	  this.$store.dispatch('drops/loadStoredDrops');
	  if (this.id) {
	    this.$store.dispatch('drops/subscribe', this.id);
	  } else {
	    this.reset();
	  }
	}

	@Watch('id')
	onIdChange(id: string) {
	  if (id) {
	    this.$store.dispatch('drops/subscribe', this.id);
	    this._s3 = undefined;
	  } else {
	    this.reset();
	  }
	}

	@Watch('drop')
	onDropChange() {
	  if (this.drop) {
	    this.from = this.drop.from;
	    this.project = this.drop.project;
	          if (this.drop.credentialsId) {
	            firebase.firestore().collection('drops').doc(this.id).collection('credentials')
	        .doc(this.drop.credentialsId)
	        .onSnapshot((snapshot) => {
	            	const data = snapshot.data();
	            	if (data) {
		              this.$store.commit('drops/insertOrUpdate', {
		              	credentials: snapshot.data(),
		              	id: this.id,
		              });
	            	}
	            });
	          }
	  } else {
	    this._s3 = undefined;
	    // this.creating = undefined;
	  }
	}

	@Ref('fromField') readonly fromField!: any;

	@Ref('projectField') readonly projectField!: any

	reset() {
	  this.creating = undefined;
	  this._s3 = undefined;
	  this.from = '';
	  this.project = '';
	  this.$nextTick(() => {
	    if (!this.from) {
	      this.fromField.focus();
	    } else {
	      this.projectField.focus();
	    }
	  });
	}

	get drop(): Drop | undefined {
	  return this.id && this.$store.state.drops.all[this.id];
	}

	get ready() {
	  return Boolean(this.id || (this.from && this.project));
	}

	readDirectoryEntry(reader: FileSystemDirectoryReader): Promise<DropFileMap> {
	  return new Promise((resolve, reject) => {
	    reader.readEntries((entries) => {
	      const promises: Promise<DropFileMap>[] = [];
	      if (entries.length) {
	        promises.push(this.readDirectoryEntry(reader));
	      }
	      entries.forEach((entry) => {
	        if (entry.isDirectory) {
	          promises.push(this.readDirectoryEntry(entry.createReader()));
	        } else {
	          promises.push(new Promise((resolve, reject) => {
	            entry.file((file) => {
	              this.readFileEntry(file, entry.fullPath.replace(/^\//, '')).then(result => resolve(result));
	            });
	          }));
	        }
	      });
	      Promise.all(promises).then((results) => {
	        if (entries.length > 0) {
	          console.log('Resolved folder', entries[0].fullPath.replace(/[^\/]*$/, ''));
	          console.log(results);
	        }
	        if (Object.keys(results).length < 1) {
	          resolve({});
	        } else {
	          // @ts-ignore
	          resolve(Object.assign(...results));
	        }
	      });
	    }, (error) => {
	      resolve({});
	    });
	  });
	}

	readFileEntry(file: File, path?: string): Promise<DropFileMap> {
	  const dropFile: DropFile = {
	    sha256: null,
	    size: file.size,
	    type: 'file',
	    analysisProgress: 0,
	    uploadProgress: 0,
	  };
	  return new Promise((resolve, reject) => {
	    this.createIfNeeded().then(() => {
	      this.$store.commit('drops/insertOrUpdateFile', {
	        id: this.id,
	        path: path || file.name,
	        dropFile,
	      });
	      const files: DropFileMap = {};
	      files[path || file.name] = dropFile;
	      resolve(files);
	      this.upload(file, path);
	    }).catch(error => this.$alert(error));
	  });
	  // new FileHasher(file, analysisProgress => {
	  // 	creation.then(() => {
	  // 		this.$store.commit('drops/insertOrUpdateFile', {
	  // 			id: this.id,
	  // 			path: path || file.name,
	  // 			dropFile: {
	  // 				analysisProgress,
	  // 			},
	  // 		});
	  // 	});
	  // }, checksum => {
	  // creation.then(() => {
	  // 	this.$store.commit('drops/insertOrUpdateFile', {
	  // 		id: this.id,
	  // 		path: path || file.name,
	  // 		dropFile: {
	  // 			checksum,
	  // 		},
	  // 	});
	  // });
	  // });
	}

	_s3?: S3;

	get s3() {
	  if (!this._s3) {
	    if (this.drop && this.drop.credentials) {
	      this._s3 = new S3({
	        accessKeyId: this.drop.credentials.AccessKeyId,
	        secretAccessKey: this.drop.credentials.SecretAccessKey,
		            endpoint: 'https://inbox.hocusfocus.no/',
		            sessionToken: this.drop.credentials.SessionToken,
		            s3ForcePathStyle: true,
	      });
	    } else {
	      throw Error('You do not have file access for this drop');
	    }
	  }
	  return this._s3;
	}

	upload(file: File, path?: string) {
	  if (!this.drop) {
	    return;
	  }

	 	// https://teppen.io/2018/06/23/aws_s3_etags/

	  const upload = this.s3.upload({
	 		Bucket: 'drop',
	 		Body: file,
	 		Key: [this.drop.folder, path || file.name].join('/').replace('//', '/'),
	  }, {
      	// partSize: 1024 * 1024 * 10,
	  });
	  upload.on('httpUploadProgress', (progress) => {
	    this.$store.commit('drops/insertOrUpdateFile', {
	      id: this.id,
	      path: path || file.name,
	      dropFile: {
	        uploadProgress: progress.loaded / progress.total,
	      },
	    });
	  });
	  upload.promise().then((result) => {
	    this.$store.commit('drops/insertOrUpdateFile', {
	      id: this.id,
	      path: path || file.name,
	      dropFile: {
	        uploadProgress: 1,
	      },
	    });
	  }).catch(error => this.$alert(error));
	}

	onDrop(event: DragEvent) {
	  event.preventDefault();
	  if (!this.ready) {
	    this.$alert('Not ready');
	    return;
	  }
	  this.dropping = false;
	  const promises: Promise<DropFileMap>[] = [];
	  event.dataTransfer && [...event.dataTransfer.items].forEach((item) => {
	    if (item.kind === 'file') {
	      const webkitEntry = item.webkitGetAsEntry() as FileSystemFileEntry | FileSystemDirectoryEntry;
	      if (webkitEntry.isDirectory) {
	        const reader = webkitEntry.createReader();
	        promises.push(this.readDirectoryEntry(reader));
	      } else {
	        promises.push(this.readFileEntry(item.getAsFile()!));
	      }
	    }
	  });
	  Promise.all(promises).then((results) => {
	    const files: DropFileMap = {};
	    Object.assign(files, ...results);
	    this.$store.dispatch('drops/addFiles', {
	      id: this.id,
	      files,
	    });
	    console.log(`${Object.keys(files).length} files read`);
	  });
	  // event.stopPropagation();
	}

	onDragover(event: DragEvent) {
	  event.preventDefault();
	  if (!this.ready) {
	    return;
	  }
	  // event.stopPropagation();
	  this.dropping = true;
	}

	onDragenter(event: DragEvent) {
	  if (!this.ready) {
	    return;
	  }
	  // event.stopPropagation();
	  this.dropping = true;
	}

	onDragleave(event: DragEvent) {
	  // event.stopPropagation();
	  // event.preventDefault();
	  this.dropping = false;
	}

	onDragexit(event: DragEvent) {
	  // console.log('onDragexit');
	  // event.stopPropagation();
	  // event.preventDefault();
	  // this.dropping = false;
	}

	onDragstart(event: DragEvent) {
		event.dataTransfer!.setData('Files', 'http://localhost:8080/drop/fGU2Q27I3odIJsxEySob/Output/pano2.jpg');
	}

	get hasFiles() {
	  return this.drop && Object.keys(this.drop.files).length > 0;
	}

	creating?: Promise<void>;

	createIfNeeded() {
	  if (!this.creating) {
	    this.creating = new Promise((resolve, reject) => {
	      if (this.drop) {
	        if (!this.drop.credentials) {
	          reject('You do not have write access to this drop');
	        } else if (this.drop.credentials!.Expiration < Date.now() + 60 * 1000) {
	          const { id } = this;
	          if (!this.drop.credentialsId) {
	            throw new Error('You do not have permission to upload to this drop.');
	          }
	          firebase.app().functions('europe-west1').httpsCallable('drop-renewCredentials')({
	            dropId: id,
	            credentialsId: this.drop.credentialsId,
	          }).then(({ data }) => {
	            console.log(data);
	            this.$store.commit('drops/insertOrUpdate', {
	              id,
	              credentials: data,
	            });
	            resolve();
	          });
	        } else {
	          resolve();
	        }
	      } else {
	        const drop = {
	          from: this.from,
	          project: this.project,
	          messages: [],
	          files: {},
	        };
	        firebase.app().functions('europe-west1').httpsCallable('drop-create')(drop).then(({ data }) => {
	          this.$store.commit('drops/insertOrUpdate', Object.assign(drop, data));
	          this.$store.commit('drops/remember', { id: data.id, credentialsId: data.credentials.id });
	          // window.localStorage.setItem(this.getCredentialsKey(data.id), data.credentials.id);
	          this.$router.replace({ params: { id: data.id } });
	          this.$store.dispatch('drops/subscribe', data.id);
	          resolve();
	        }).catch(error => reject(error));
	      }
	    });
	  }
	  return this.creating;
	}

	sendMessage() {
	  this.sendingMessage = true;
	  this.createIfNeeded().then(() => {
	    if (!this.drop || !this.drop.credentialsId) {
	      throw new Error('You do not have permission to post to this drop.');
	    }
	    firebase.app().functions('europe-west1').httpsCallable('drop-message')({
	      dropId: this.$route.params.id,
	      credentialsId: this.drop.credentialsId,
	      message: this.message,
	    }).then(({ data }) => {
	      this.message = '';
	    });
	  }).finally(() => {
	    this.sendingMessage = false;
	  }).catch(error => this.$alert(error));
	}
}
